// this file added for individual by Bearer Web Developer
import React from "react";
import { useAppState } from "../../../../states/app-state";
import styles from './createAccountButton.module.scss';
import { Button } from "@mui/material";
import { SigninSituation } from "../../../../states/signinState";

const CreateAccountButton: React.FC = () => {

    const appState = useAppState();
    const { login, signin } = appState;

    const handleCreateAccount = () => {
        if (!login.uid) {
            // open createAccount
            signin.setSituation(SigninSituation.CreateAccount);
        }
    }
    return (
        <>
            <div className={styles.or}>
                <span className={styles.left_line}></span>
                <span className={styles.or_text}>OR</span>
                <span className={styles.right_line}></span>
            </div>
            <div className={styles.signup}>
                <Button type="button" onClick={handleCreateAccount} rel="noreferre">Create Account</Button>
            </div>
        </>
    )
}
export default CreateAccountButton;